if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_components_CrudComponents_Secretars_vue":1,"src_components_Examinare_vue":1,"node_modules_vuetify_lib_components_VTabs_VTab_js-node_modules_vuetify_lib_components_VTabs_V-496fdd":1,"src_components_CustomExams_vue-node_modules_vuetify_src_components_VCheckbox_VCheckbox_sass":1,"src_components_TeacherExams_vue-node_modules_vuetify_src_components_VCheckbox_VCheckbox_sass":1,"src_components_ManageAppointments_vue-node_modules_vuetify_src_components_VDatePicker_VDatePi-019f74":1,"src_components_Dashboard_vue":1,"src_components_Login_vue-node_modules_simple-keyboard_build_css_index_css":1,"src_components_Exam_vue-node_modules_simple-keyboard_build_css_index_css":1,"src_components_Question_vue-node_modules_vuetify_src_components_VCheckbox_VCheckbox_sass-node-76b543":1,"src_components_NewQuestion_vue":1,"src_components_ExamSchedule_vue":1,"src_components_Imports_vue-node_modules_vuetify_src_components_VCheckbox_VCheckbox_sass-node_-6e902d":1,"src_components_ExamsSimulation_vue":1,"src_components_ExamAppointments_vue-node_modules_vuetify_src_components_VDatePicker_VDatePick-d99921":1,"src_components_DisciplinesList_vue":1,"src_components_DisciplinesManage_vue":1,"src_components_ExamsPreview_vue":1,"src_components_Admin_vue":1,"src_components_TemplateExamView_vue":1,"src_components_TemplateExamEdit_vue":1,"src_components_ExamsContest_vue":1,"src_components_ExamContestEdit_vue":1,"src_components_StudentsExams_vue-node_modules_vuetify_src_components_VCheckbox_VCheckbox_sass":1,"src_components_GradesStatistics_vue":1,"src_components_RrwebPlayer_vue":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr